import React from "react";
import Clienthomemenu from "../Menus/Adminhomemenu";

export default function PrivacyPolicy() {
  return (
    <>
      <Clienthomemenu title="EasyITI" />

      <div className="container mt-5 pt-4" style={{ minHeight: "750px" }}>
        
        {/* HEADER */}
        <div className="card shadow-lg mb-4 border-0">
          <div className="card-body text-center bg-dark text-white rounded">
            <h3 className="mb-2">🔒 Privacy Policy</h3>

            <p className="mb-0">
              Your privacy and data security are important to us.
            </p>
          </div>
        </div>

        {/* INTRO */}
        <div className="card shadow border-0 mb-4">
          <div className="card-body">
            <h4>📘 Information Collection</h4>

            <p className="text-muted">
              EasyITI may collect user information such as Name, Mobile Number,
              Email ID, and Test Performance for better service experience.
            </p>
          </div>
        </div>

        {/* POLICY ITEMS */}
        <div className="row g-4">

          {/* Usage */}
          <div className="col-md-6">
            <div className="card h-100 shadow border-0">
              <div className="card-body">
                <h5>📊 How We Use Data</h5>

                <ul className="text-muted">
                  <li>Improve student experience</li>
                  <li>Manage online tests</li>
                  <li>Track performance history</li>
                  <li>Enhance application security</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Security */}
          <div className="col-md-6">
            <div className="card h-100 shadow border-0">
              <div className="card-body">
                <h5>🔐 Data Security</h5>

                <p className="text-muted">
                  We use secure systems and technologies to protect user
                  information from unauthorized access.
                </p>
              </div>
            </div>
          </div>

          {/* Third Party */}
          <div className="col-md-6">
            <div className="card h-100 shadow border-0">
              <div className="card-body">
                <h5>🌐 Third Party Services</h5>

                <p className="text-muted">
                  EasyITI may use Google Firebase, Analytics, AdMob, and other
                  Google services for app improvement and analytics.
                </p>
              </div>
            </div>
          </div>

          {/* Changes */}
          <div className="col-md-6">
            <div className="card h-100 shadow border-0">
              <div className="card-body">
                <h5>📝 Policy Updates</h5>

                <p className="text-muted">
                  We may update this Privacy Policy from time to time.
                  Changes will be updated on this page.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CONTACT */}
        <div className="card shadow border-0 mt-4 bg-light">
          <div className="card-body text-center">
            <h5>📧 Contact Us</h5>

            <p className="mb-1">
              foursighttechnosoft@gmail.com
            </p>

            <p className="mb-0 text-muted">
              https://4sighttechnosoft.co.in/easyiti
            </p>
          </div>
        </div>
      </div>
    </>
  );
}